var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.865 3l9.526 16.5a1 1 0 01-.866 1.5H2.473a1 1 0 01-.866-1.5L11.133 3a1 1 0 011.732 0zm-1.866 13v2h2v-2h-2zm0-7v5h2V9h-2z",
    fill: "rgba(255,255,255,1)"
  })));
}
export default __webpack_public_path__ + "static/svg/alert-fill.svg";
export { SvgAlertFill as ReactComponent };